import {createEvent, type Emitter, type Listener} from "react-event-hook";

type Event = {
    /**
     * Listen for the video-almost-complete event.
     */
    useVideoAlmostCompleteListener: Listener<void>;

    /**
     * Emit the video-almost-complete event.
     *
     * This event is raised by the video renderer to signal that a video has
     * has been played to 90% completion.
     */
    emitVideoAlmostComplete: Emitter<void>;
};

export const {useVideoAlmostCompleteListener, emitVideoAlmostComplete} =
    createEvent("video-almost-complete")() as Event;
